export default function containsNumeric (value) {
  return /\d/.test(value)
}
